import React from 'react';

import { triggerGTAGInternalNavEvent } from '@/utils/analyticTracks';

import {
  BoxLinkWrapper,
  LinkLogo,
  LinkWrapper,
  Links,
  WrapperLogo,
} from './HelpComponents.styled';
import { linkData } from './linkData';

const HelpComponents = () => {
  return (
    <BoxLinkWrapper>
      {linkData.map((link, id) => (
        <LinkWrapper key={id}>
          <WrapperLogo>
            <LinkLogo src={link.logo} />
          </WrapperLogo>
          {id === 0 ? (
            <a
              href={link.path}
              onClick={() => triggerGTAGInternalNavEvent(link.path)}
              style={{ textDecoration: 'none' }}
            >
              {link.linkName}
            </a>
          ) : (
            <Links
              onClick={() =>
                triggerGTAGInternalNavEvent(
                  `https://atpgamezone.com/${link.path}`,
                )
              }
              to={link.path}
            >
              {link.linkName}
            </Links>
          )}
        </LinkWrapper>
      ))}
    </BoxLinkWrapper>
  );
};

export default HelpComponents;
